import { Ziggy } from "../Ziggy";
import type { ZiggyAge } from "../../lib/ziggy";
import type { PortalStrings } from "../../lib/i18n/usePortalLocale";

/** Figma: plain Learn title left, canonical Ziggy (variant × age) right. */
export function LearnPageHeader({
  ziggyAge = "grown",
  strings,
}: {
  ziggyAge?: ZiggyAge;
  strings: Pick<PortalStrings, "learnPageTitle" | "learnPageSubtitle">;
}) {
  return (
    <div className="flex items-end justify-between gap-3 sm:gap-4">
      <div className="min-w-0 flex-1 pb-1">
        <h1 className="font-display text-foreground text-[1.75rem] font-semibold leading-tight sm:text-3xl">
          {strings.learnPageTitle}
        </h1>
        <p className="text-muted-foreground mt-1.5 max-w-md text-sm sm:text-base">
          {strings.learnPageSubtitle}
        </p>
      </div>
      <Ziggy
        pose="reading"
        age={ziggyAge}
        size={92}
        glow
        float={false}
        alt=""
        priority
        className="shrink-0"
      />
    </div>
  );
}
